export default __webpack_public_path__ + "static/media/bg12.9be313c1.svg";